/**
 * Keyboard-nudge helper for canvas accessibility.
 *
 * Maps an arrow key to a position delta for the selected node(s). A plain arrow
 * moves by the grid step (`gridSize`); holding Shift gives a 1px fine nudge.
 * Returns `null` for any non-arrow key so callers can ignore it.
 */
export function computeNudge(
  key: string,
  shift: boolean,
  gridSize: number,
): { dx: number; dy: number } | null {
  const step = shift ? 1 : gridSize || 1
  switch (key) {
    case 'ArrowRight':
      return { dx: step, dy: 0 }
    case 'ArrowLeft':
      return { dx: -step, dy: 0 }
    case 'ArrowUp':
      return { dx: 0, dy: -step }
    case 'ArrowDown':
      return { dx: 0, dy: step }
    default:
      return null
  }
}
